import { render } from "./StandardBoard.vue?vue&type=template&id=0196d4f0"
import script from "./StandardBoard.vue?vue&type=script&lang=js"
export * from "./StandardBoard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__